export var DATE_PICKER_TIME_SELECTOR_CLASS_PREFIX = 'DatePickerTimeSelector';
export var DATE_PICKER_TIME_SELECTOR_MODE_AM = 'am';
export var DATE_PICKER_TIME_SELECTOR_MODE_PM = 'pm';